<template>
  <editable-base
    ref="base"
    :mode="mode"
    :label="label"
    :error-message="errorMessage"
    :readonly="readonly"
    :show-buttons="showButtons"
    :showErrorMessage="showErrorMessage"
  >
    <toggle-button
      v-if="mode === modes.edit"
      @click="handleToggleClick"
      :class="[
        'align-self-center',
        'est-input',
        mode === modes.processing ? 'text-secondary' : '',
        readonly ? 'readonly' : ''
      ]"
      :id="id"
      :on="editValue"
    />
    <b-form-input
      v-else
      @click="handleMaybeEditClick"
      v-model="inputText"
      :plaintext="true"
    />
  </editable-base>
</template>

<script>
import EditableBase, { Mixin } from "./EditableBase";
import ToggleButton from "@/components/forms/ToggleButton";
import { BFormInput } from "bootstrap-vue";

// todo on save, disable field, emit event, wait for response -- may fail validation

export default {
  name: "EditableBool",
  mixins: [Mixin],
  methods: {
    handleToggleClick() {
      this.editValue = !this.editValue;
    },
    getInputText() {
      let match =
        "undefined" === typeof this.editValue
          ? this.initialValue
          : this.editValue;
      return match ? this.onText : this.offText;
    }
  },
  watch: {
    value() {
      this.inputText = this.getInputText();
    }
  },
  data() {
    return {
      inputText: this.getInputText()
    };
  },
  props: {
    onText: { type: String, default: "Yes" },
    offText: { type: String, default: "No" },
    initialValue: { type: Boolean, default: false }
  },
  components: {
    BFormInput,
    EditableBase,
    ToggleButton
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
